import { StaticApiState } from './types/static-file.types';
import { GetterTree } from 'vuex';
import { RootState } from '@/store/store';

export const staticFileGetters: GetterTree<StaticApiState, RootState> = {};
